import {
  GraduationCap,
  Files,
  Layers,
  LayoutDashboard,
  MessagesSquare,
  Route,
  School,
  UsersRound,
} from "lucide-react";
import type { Workspace } from "../types/shell.js";
import type { ShellNavigationItem, ShellNavigationSection } from "../types/shell.js";

export const employeeNavigation: readonly ShellNavigationItem[] = [
  { to: "/me", labelKey: "nav.learningRoute", icon: Route, controlId: "nav.learningRoute", end: true },
  { to: "/me/chat", labelKey: "nav.chat", icon: MessagesSquare, controlId: "nav.chat" },
];

export const mentorNavigationItem: ShellNavigationItem = {
  to: "/manage/mentees",
  labelKey: "nav.mentees",
  icon: GraduationCap,
  controlId: "nav.mentees",
  end: true,
};

export const supervisorNavigation: readonly ShellNavigationSection[] = [
  {
    items: [{ to: "/manage/chat", labelKey: "nav.chat", icon: MessagesSquare, controlId: "nav.chat" }],
  },
  {
    labelKey: "nav.managementSection",
    items: [
      {
        to: "/manage",
        labelKey: "nav.managerDashboard",
        icon: LayoutDashboard,
        controlId: "nav.managerDashboard",
        end: true,
      },
      { to: "/manage/users", labelKey: "nav.users", icon: UsersRound, controlId: "nav.users" },
      {
        to: "/manage/school",
        labelKey: "nav.school",
        icon: School,
        controlId: "nav.school",
      },
      { to: "/manage/documents", labelKey: "nav.documents", icon: Files, controlId: "nav.documents" },
    ],
  },
];

export const adminNavigation: readonly ShellNavigationSection[] = [
  {
    items: [
      {
        to: "/admin/situation-cards",
        labelKey: "nav.situationCards",
        icon: Layers,
        controlId: "nav.admin.situation-cards",
      },
    ],
  },
];

export const navigationForMobile = (workspace: Workspace, mentor = false): readonly ShellNavigationItem[] => {
  const sections =
    workspace === "employee"
      ? [{ items: employeeNavigation }]
      : workspace === "admin"
        ? adminNavigation
        : mentor
          ? [{ items: [mentorNavigationItem] }, ...supervisorNavigation]
          : supervisorNavigation;
  return sections.flatMap((section) => section.items);
};
